<template>
    <div id="address-book">
        <van-pull-refresh v-model="isLoading" :finished="finished" @load="onLoad">
            <van-search placeholder="姓名/手机号码" v-model="searchKey"/>
            <van-collapse v-model="activeName" accordion>
                <van-collapse-item title="拉包工" :value="count[2]" name="1">
                    <div @click="modify(item.id,item.type)" class="user-info van-hairline--bottom" v-for="item in packWorkers" :key="item.id">
                        <span class="user-photo" :style="{backgroundImage:'url('+item.photo+')'}"></span>
                        <div class="van-cell-text">
                            <h3 class="username">{{item.name}}</h3>
                            <p class="user-mobile">{{item.phone}}</p>
                        </div>
                        <div class="icon">
                            <a :href="item.tel">
                                <van-icon name="phone" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                            <a :href="item.sms">
                                <van-icon name="chat" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                        </div>
                    </div>
                </van-collapse-item>
                <van-collapse-item title="收货人" :value="count[1]" name="2">
                    <div class="user-info van-hairline--bottom" v-for="item in accept" :key="item.id">
                        <span class="user-photo" :style="{backgroundImage:'url('+item.photo+')'}"></span>
                        <div class="van-cell-text">
                            <h3 class="username">{{item.name}}</h3>
                            <p class="user-mobile">{{item.phone}}</p>
                        </div>
                        <div class="icon">
                            <a :href="item.tel">
                                <van-icon name="phone" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                            <a :href="item.sms">
                                <van-icon name="chat" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                        </div>
                    </div>
                </van-collapse-item>
                <van-collapse-item title="发货人" :value="count[0]" name="3">
                    <div class="user-info van-hairline--bottom" v-for="item in send" :key="item.id">
                        <span class="user-photo" :style="{backgroundImage:'url('+item.photo+')'}"></span>
                        <div class="van-cell-text">
                            <h3 class="username">{{item.name}}</h3>
                            <p class="user-mobile">{{item.phone}}</p>
                        </div>
                        <div class="icon">
                            <a :href="item.tel">
                                <van-icon name="phone" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                            <a :href="item.sms">
                                <van-icon name="chat" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                        </div>
                    </div>
                </van-collapse-item>
                <van-collapse-item title="物流" :value="count[3]" name="4">
                    <div class="user-info van-hairline--bottom" v-for="item in wuliu" :key="item.id">
                        <span class="user-photo" :style="{backgroundImage:'url('+item.photo+')'}"></span>
                        <div class="van-cell-text">
                            <h3 class="username">{{item.name}}</h3>
                            <p class="user-mobile">{{item.phone}}</p>
                        </div>
                        <div class="icon">
                            <a :href="item.tel">
                                <van-icon name="phone" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                            <a :href="item.sms">
                                <van-icon name="chat" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                        </div>
                    </div>
                </van-collapse-item>
                <van-collapse-item title="其他" :value="count[4]" name="5">
                    <div class="user-info van-hairline--bottom" v-for="item in other" :key="item.id">
                        <span class="user-photo" :style="{backgroundImage:'url('+item.photo+')'}"></span>
                        <div class="van-cell-text">
                            <h3 class="username">{{item.name}}</h3>
                            <p class="user-mobile">{{item.phone}}</p>
                        </div>
                        <div class="icon">
                            <a :href="item.tel">
                                <van-icon name="phone" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                            <a :href="item.sms">
                                <van-icon name="chat" color="#0b92e6" size="0.5rem"></van-icon>
                            </a>
                        </div>
                    </div>
                </van-collapse-item>
            </van-collapse>
        </van-pull-refresh>
    </div>
</template>

<script>
export default {
  name: "AddressBook",
  data() {
    return {
      activeName: 1,
      isLoading: false,
      finished: false,
      searchKey: "",
      tabsIndex: 0,
      count: ["0/0", "0/0", "0/0", "0/0", "0/0"],
      packWorkers: [],
      send: [],
      accept: [],
      wuliu: [],
      other: []
    };
  },
  created() {
    this.getList(1);
    this.getList(2);
    this.getList(3);
    this.getList(4);
    this.getList(5);
  },
  methods: {
    // 获取列表
    getList(type) {
      let params = {
        params: {
          name: "",
          type
        }
      };
      this.$axios.post("merchantConcat/getListByType", params).then(res => {
        if (res.data.code === 200) {
          if (res.data.data === "") {
            return false;
          }
          let data = res.data.data[0].array;
          let online = 0;
          data.forEach(value => {
            if (value.workStatus === 1) {
              online++;
            }
            if (!value.photo) {
              value.photo = require("../../assets/btn_headportrait.png");
            }
          });
          this.count[type - 1] = online + "/" + data.length;
          switch (type) {
            case 3:
              this.packWorkers = data || [];
              break;
            case 2:
              this.accept = data || [];
              break;
            case 1:
              this.send = data || [];
              break;
            case 4:
              this.wuliu = data || [];
              break;
            case 5:
              this.other = data || [];
              break;
          }
        }
      });
    },
    onLoad() {}
    // TODO: 修改联系人
    // modify(id, type) {}
  }
};
</script>

<style scoped lang="scss">
#address-book {
  .van-pull-refresh {
    overflow: unset;
    .user-info {
      display: flex;
      align-items: center;
      padding: 15px 0;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        padding-bottom: 0;
        &:after {
          border: 0;
        }
      }
      .user-photo {
        display: block;
        width: 1.1rem;
        height: 1.1rem;
        border-radius: 8px;
        background-repeat: no-repeat;
        -webkit-background-size: 100%;
        background-size: 100%;
        background-position: center;
        margin-right: 0.25rem;
      }
      .van-cell-text {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        flex: 1;
        .username {
          font-size: 0.4rem;
        }
        .user-mobile {
          font-size: 0.35rem;
          color: #666;
        }
      }
      .icon {
        -webkit-transform: translateY(3px);
        -moz-transform: translateY(3px);
        -ms-transform: translateY(3px);
        -o-transform: translateY(3px);
        transform: translateY(3px);
        .van-icon {
          margin-right: 0.4rem;
        }
      }
    }
  }
}
</style>
